import CheckMaxFreespinsReached from "slotworks/state-machine/standard/decisions/check-max-freespins-reached";
import FreespinsRetriggered from "slotworks/state-machine/standard/decisions/freespins-retriggered";
import FreespinsTriggered from "slotworks/state-machine/standard/decisions/freespins-triggered";
import HasExpansion from "slotworks/state-machine/standard/decisions/has-expansion";
import InFreespins from "slotworks/state-machine/standard/decisions/in-freespins";
import IsAutoplay from "slotworks/state-machine/standard/decisions/is-autoplay";
import IsRecovery from "slotworks/state-machine/standard/decisions/is-recovery";
import IsRecoveryFreespins from "slotworks/state-machine/standard/decisions/is-recovery-freespins";
import IsWin from "slotworks/state-machine/standard/decisions/is-win";
import IsWinOverThreshold from "slotworks/state-machine/standard/decisions/is-win-over-threshold";
import ShouldExitFreespins from "slotworks/state-machine/standard/decisions/should-exit-freespins";
import Autoplay from "slotworks/state-machine/standard/states/autoplay";
import EnterFreespins from "slotworks/state-machine/standard/states/enter-freespins";
import ExitFreespins from "slotworks/state-machine/standard/states/exit-freespins";
import ExpandSymbols from "slotworks/state-machine/standard/states/expand-symbols";
import FreespinIdle from "slotworks/state-machine/standard/states/freespin-idle";
import GameOver from "slotworks/state-machine/standard/states/game-over";
import Idle from "slotworks/state-machine/standard/states/idle";
import Init from "slotworks/state-machine/standard/states/init";
import LoopWins from "slotworks/state-machine/standard/states/loop-wins";
import MaxFreespins from "slotworks/state-machine/standard/states/max-freespins";
import Recover from "slotworks/state-machine/standard/states/recover";
import RecoverFreespins from "slotworks/state-machine/standard/states/recover-freespins";
import RecoverFreespinsMode from "slotworks/state-machine/standard/states/recover-freespins-mode";
import RecoverMatrix from "slotworks/state-machine/standard/states/recover-matrix";
import RecoverSpin from "slotworks/state-machine/standard/states/recover-spin";
import RecoverStickySymbols from "slotworks/state-machine/standard/states/recover-sticky-symbols";
import RequestFreespin from "slotworks/state-machine/standard/states/request-freespin";
import RequestSpin from "slotworks/state-machine/standard/states/request-spin";
import RetriggerFreespins from "slotworks/state-machine/standard/states/retrigger-freespins";
import ShowWinLines from "slotworks/state-machine/standard/states/show-win-lines";
import Spin from "slotworks/state-machine/standard/states/spin";
import WinCycle from "slotworks/state-machine/standard/super-states/win-cycle";
import StateMachine from "slotworks/state-machine/state-machine";
import StateRegister from "slotworks/state-machine/state-register";
import IsGambleWin from "./decisions/is-gamble-win-check";
import ShouldStartGamble from "./decisions/should-start-gamble";
import CascadeSymbols from "./states/cascade-symbols";
import GambleSend from "./states/gamble-send";
import WinCycleGamble from "./super-states/win-cycle-gamble";

export default class StandardStates {

    public static init() {

        // --- Main game
        // States
        StateRegister.add("init", new Init(StateMachine));
        StateRegister.add("idle", new Idle(StateMachine));
        StateRegister.add("request-spin", new RequestSpin(StateMachine));
        StateRegister.add("spin", new Spin(StateMachine));
        StateRegister.add("show-win-lines", new ShowWinLines(StateMachine));
        StateRegister.add("autoplay", new Autoplay(StateMachine));
        StateRegister.add("game-over", new GameOver(StateMachine));
        StateRegister.add("loop-wins", new LoopWins(StateMachine));
        StateRegister.add("expand-symbols", new ExpandSymbols(StateMachine));
        StateRegister.add("cascade-symbols", new CascadeSymbols(StateMachine));

        // Decisions
        StateRegister.add("is-autoplay", new IsAutoplay());
        StateRegister.add("is-win-over-threshold", new IsWinOverThreshold());
        StateRegister.add("is-win", new IsWin());
        StateRegister.add("has-expansion", new HasExpansion());

        // Super states
        StateRegister.add("win-cycle", new WinCycle(StateMachine));

        // --- Free spins
        // States
        StateRegister.add("enter-freespins", new EnterFreespins(StateMachine));
        StateRegister.add("exit-freespins", new ExitFreespins(StateMachine));
        StateRegister.add("retrigger-freespins", new RetriggerFreespins(StateMachine));
        StateRegister.add("max-freespins", new MaxFreespins(StateMachine));
        StateRegister.add("freespin-idle", new FreespinIdle(StateMachine));
        StateRegister.add("request-freespin", new RequestFreespin(StateMachine));

        // Decisions
        StateRegister.add("freespins-triggered", new FreespinsTriggered());
        StateRegister.add("freespins-retriggered", new FreespinsRetriggered());
        StateRegister.add("in-freespins", new InFreespins());
        StateRegister.add("should-exit-freespins", new ShouldExitFreespins());
        StateRegister.add("max-freespins-reached", new CheckMaxFreespinsReached());

        // --- Recovery
        // States
        StateRegister.add("recover", new Recover(StateMachine));
        StateRegister.add("recover-matrix", new RecoverMatrix(StateMachine));
        StateRegister.add("recover-spin", new RecoverSpin(StateMachine));
        StateRegister.add("recover-freespins", new RecoverFreespins(StateMachine));
        StateRegister.add("recover-freespins-mode", new RecoverFreespinsMode(StateMachine));
        StateRegister.add("recover-sticky-symbols", new RecoverStickySymbols(StateMachine));

        // Decisions
        StateRegister.add("is-recovery", new IsRecovery());
        StateRegister.add("is-recovery-freespins", new IsRecoveryFreespins());

        // Gamble
        StateRegister.add("gamble-send", new GambleSend(StateMachine));
        StateRegister.add("should-start-gamble", new ShouldStartGamble());
        StateRegister.add("is-gamble-win-check", new IsGambleWin());
        StateRegister.add("win-cycle-gamble", new WinCycleGamble(StateMachine));
    }
}
